import { apiService } from "@/services/api/apiService";

export const API_Authorization_logout = () => {
  return new Promise<void>((resolve, reject) => {
    apiService
      .send({
        endpoint: "/api/logout",
        method: "post",
      })
      .then(() => {
        apiService.clearAuth();
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  });
};
